// src/v3/LayoutGrid/index.tsx
import { cva, cx } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
var grid = cva("", {
  variants: {
    rowGap: {
      0: "ui-gap-y-0",
      8: "ui-gap-y-2",
      16: "ui-gap-y-4",
      24: "ui-gap-y-6",
      32: "ui-gap-y-8",
      40: "ui-gap-y-10",
      48: "ui-gap-y-12",
      56: "ui-gap-y-14",
      64: "ui-gap-y-16",
      80: "ui-gap-y-20",
      96: "ui-gap-y-24",
      112: "ui-gap-y-28",
      128: "ui-gap-y-32",
      144: "ui-gap-y-36",
      160: "ui-gap-y-40",
      176: "ui-gap-y-44"
    }
  },
  defaultVariants: {
    rowGap: 8
  }
});
function LayoutGrid({
  children,
  className = "",
  Element = "div",
  rowGap,
  ...props
}) {
  return /* @__PURE__ */ jsx(Element, {
    className: grid({ rowGap, className: cx("gridContainerV3", className) }),
    "data-cy": "layout-grid",
    ...props,
    children
  });
}
LayoutGrid.displayName = "LayoutGrid";
export {
  LayoutGrid
};
//# sourceMappingURL=index.mjs.map